import { useCallback, useState } from "react";

import { OrderStep } from "../../constants";
import { TOrderStepsData } from "../../types";

type TStepsReturn = {
  steps: TOrderStepsData;
  updateSteps: (steps: Partial<TOrderStepsData>) => void;
};

const defaultStepsData: TOrderStepsData = {
  [OrderStep.PackageInfo]: true,
  [OrderStep.ShipmentDetails]: true,
  [OrderStep.SenderDetails]: false,
  [OrderStep.ReceiverDetails]: false,
  [OrderStep.Summary]: true,
  [OrderStep.Success]: true,
};

const useSteps = (): TStepsReturn => {
  const [steps, setSteps] = useState<TOrderStepsData>(defaultStepsData);

  const updateSteps = useCallback((newSteps: Partial<TOrderStepsData>) => {
    setSteps((currentSteps) => ({ ...currentSteps, ...newSteps }));
  }, []);

  return { steps, updateSteps };
};
export default useSteps;
